import { useState } from "react";

export default function useAddPrice(props) {
  const [price, setPrice] = useState(0);
  const [currency, setCurrency] = useState("");
  const [priceLabel, setPriceLabel] = useState("");
  const { onSavePrice } = props;

  const handlePriceChange = (e) => {
    setPrice(e.target.value);
  };

  const handleCurrencyChange = (e) => {
    setCurrency(e.target.value);
  };

  const handleSavePrice = () => {
    onSavePrice && onSavePrice(price, currency, priceLabel);
  };

  const handlePriceLabelChange = (e) => {
    setPriceLabel(e.target.value);
  };

  return {
    price,
    currency,
    priceLabel,
    onPriceChange: handlePriceChange,
    onCurrencyChange: handleCurrencyChange,
    onPriceLabelChange: handlePriceLabelChange,
    onSave: handleSavePrice,
  };
}
